import cn from 'classnames';
import { Discord, Google, Twitter, Twitch } from './Social';

type IconName = 'Discord' | 'Google' | 'Twitch' | 'Twitter';

export interface IconProps {
  className?: string;
  name: IconName;
}

function getComponent(name: IconName) {
  switch (name) {
    case 'Discord':
      return <Discord />;
    case 'Google':
      return <Google />;
    case 'Twitch':
      return <Twitch />;
    case 'Twitter':
      return <Twitter />;
    default:
      return null;
  }
}

export function Icon({ className, name }: IconProps) {
  return (
    <svg
      className={cn('w-5 h-5', className)}
      aria-hidden="true"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      {getComponent(name)}
    </svg>
  );
}

export default Icon;
